import { Card, FormControl, FormHelperText, Grid2, IconButton, Slide, Tooltip } from "@mui/material"
import MaterialButton from "../../../../components/MaterialButton";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { Close, Send } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { addmutation, fetchpermissionhours, updatemutation } from "./permissionData";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";



const PermissionDialog = ({
  permissionOpen,
  setPermissionOpen,
  selectedDate
}) => {
  
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const nav = useNavigate();
  const data = sessionStorage.getItem("user");
  const parsedData = JSON.parse(data);
  const encodedId = parsedData?.id;
  const [iseditatable, seteditable] = useState(true);
  const [remaininghours, setremaininghours] = useState("");
  const [permission, setPermission] = useState({
    userId: encodedId,
    permissionOn: selectedDate,
    permissionFrom: "",
    permissionTill: "",
    permissionTillStatus: "",
    reason: "",
    reasonStatus: "",
  });
  const [errors, setErrors] = useState({
    TotalPermissionsHours: false,
    permissionOn: false,
    permissionFrom: false,
    permissionTill: false,
    reason: false,
    timeOrder: false, // New error state for time order validation
  });

  useEffect(() => {
    setPermission({
      ...permission,
      permissionOn: selectedDate
    })
  },[selectedDate])

  useEffect(() => {
    const fetchpermission = async () => {
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: fetchpermissionhours,
            variables: {
              userid: parsedData?.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setremaininghours(4);

        let val = response.data.data.permissionsByUser.data[0].balanceHours;

        setremaininghours(val);
      } catch (error) {
        console.error(error, "err");
      }
    };
    if(permissionOpen){
      fetchpermission();
    }
  }, [permissionOpen]);

  //handle change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update permission state
    setPermission((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validation logic
    let isValid = true;

    if (name === "remaininghours" && (isNaN(value) || value <= 0)) {
      isValid = false;
    }
    if (name === "permissionOn" && !value) {
      isValid = false;
    }
    if (name === "permissionTill" && !value) {
      isValid = false;
    }

    let timeOrderValid = true;
    let fromTime =
      name === "permissionFrom" ? value : permission.permissionFrom;
    let tillTime =
      name === "permissionTill" ? value : permission.permissionTill;

    if (fromTime && tillTime && fromTime >= tillTime) {
      timeOrderValid = false;
    }

    // Update error state
    setErrors((prev) => ({
      ...prev,
      [name]: !isValid,
      timeOrder: !timeOrderValid,
    }));
  };

  //handle change for department
  const handleDepartmentDatachange = (event) => {
    let departmentState = { ...permission };
    switch (event.target.name) {
      case "reason": {
        const alphaNumberLengthRegex = new RegExp("^([A-Za-z ]{1,40})$");
        if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }
    departmentState[event.target.name] = event.target.value;
    setPermission(departmentState);
  };

  //Submit Function
  const confirmsubmit = async () => {
    if (isFormValid()) {
      if (id) {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: updatemutation,
              variables: {
                permissionId: id,
                permissionOn: permission?.permissionOn,

                permissionFrom: permission?.permissionFrom,

                permissionTill: permission?.permissionTill,
                teamleaderId: parsedData.teamleader,

                reason: permission?.reason,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response?.data?.data?.updatePermission !== null) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Permission updated successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
            nav("/permission");
          } else {
            Swal.fire({
              icon: "error",
              title: response?.data?.errors[0]?.message,
            });
          }
        } catch (error) {
          console.error(error, "err");
        }
      } else {
        //create

        try {
          const response = await axios.post(
            BASEURL,
            {
              query: addmutation,
              variables: {
                input: {
                  userId: permission?.userId,

                  permissionOn: permission?.permissionOn,

                  permissionFrom: permission?.permissionFrom,

                  permissionTill: permission?.permissionTill,

                  reason: permission?.reason,
                  teamleaderId: parsedData.teamleader,

                  screenName: "Permission Approval",
                },
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          let data = response.data.data.createPermission.success;
          let message = response.data.data.createPermission.message;
          let Errordata = response.data.errors;

          if (data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Permission Requested successfully!",
              showConfirmButton: false,
              timer: 2500,
            });

            handleClosePermission();
          } else if (!data) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: message,
              showConfirmButton: false,
              timer: 4500,
            });
          } else if (
            Errordata[0]?.message ==
            "You already have a pending permission request."
          ) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: Errordata[0]?.message,
              showConfirmButton: false,
              timer: 4500,
            });
          } else if (
            Errordata[0]?.message ==
            "Your permission request overlaps with an existing pending or approved leave request."
          ) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: Errordata[0]?.message,
              showConfirmButton: false,
              timer: 4500,
            });
          }
        } catch (error) {
          console.error(error, "err");
        }
      }
    } else {
      console.error("Please fill all fields correctly.");
    }
    //  setSnackbar(true)
  };

  //Submit Validation Function
  const isFormValid = () => {
    return (
      remaininghours &&
      permission.permissionOn &&
      permission.permissionFrom &&
      permission.permissionTill &&
      permission.reason &&
      !Object.values(errors).includes(true)
    );
  };

  const handleClosePermission = () => {
      setPermissionOpen(false);
      setPermission({
        userId: encodedId,
        permissionOn: "",
        permissionFrom: "",
        permissionTill: "",
        permissionTillStatus: "",
        reason: "",
        reasonStatus: "",
      })
  };
  
  return (
    <>
      {permissionOpen && (
        <MaterialBox
        onClick={handleClosePermission}
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.59)",
            zIndex: 2,
        }}
        />
      )}
      <Slide
      timeout={1000}
      direction="right"
      in={permissionOpen}
      mountOnEnter unmountOnExit>
        <MaterialBox
        p={1}
        className="custom-dialog-box"
        open={permissionOpen}
        onClose={(event, reason) => {
            if (reason !== 'backdropClick') handleClosePermission();
        }}>
          {/* Dialog Heading */}
            <MaterialBox>
              <Grid2 container alignItems="center">
                  {/* Title */}
                  <Grid2 size={{xs:10}} display="flex" justifyContent="center">
                    <MaterialTypography variant="h5" fontWeight="medium">
                     Permission Form
                    </MaterialTypography>
                  </Grid2>

                  <Grid2 size={{xs:2}} display="flex" justifyContent="flex-end">
                    {/* Edit button to be implmented when view page exists*/}

                      {/* <Tooltip title="Edit" disableInteractive>
                        <IconButton
                          size="small"
                          disableElevation
                          color="success"
                          onClick={() => seteditable(true)}
                          sx={{color: "#757575"}}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip> */}


                    {/* Close button */}
                    <Tooltip title="Close" disableInteractive enterDelay={1200}>
                      <IconButton onClick={handleClosePermission}>
                        <Close fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Grid2>

              </Grid2>
            </MaterialBox>
            <>
            {selectedDate < new Date(new Date().setDate(new Date().getDate())).toISOString().slice(0,10) ?
            (
              // Cannot Apply Permission Error Throwing
              <Card variant="outlined" raised style={{ padding: "12px", borderRadius: "10px", margin: "10px" , textAlign: "center" }}>
                <MaterialTypography variant="body2" color="error">
                 Permission cannot be applied on {new Date(selectedDate).toDateString()}.
                </MaterialTypography>
              </Card>
            ):
              <>
              {/* Dialog Content */}
              <MaterialBox p={1}>
                <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Total Permissions Hours{" "}
                          <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
      
                      <MaterialInput
                        name="remaining"
                        disabled
                        value={remaininghours}
                        onChange={handleChange}
                        error={errors.TotalPermissionsHours}
                        success={!errors.TotalPermissionsHours}
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm:12, md: 6, lg: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Permission On <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
      
                      <MaterialInput
                        name="permissionOn"
                        type="date"
                        value={permission.permissionOn}
                        onChange={handleChange}
                        error={errors.permissionOn}
                        disabled={!iseditatable}
                        success={permission.permissionOn && !errors.permissionOn}
                        inputProps={{
                          min: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </Grid2>
      
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Permission From <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
      
                      <MaterialInput
                        name="permissionFrom"
                        type="time"
                        value={permission.permissionFrom}
                        onChange={handleChange}
                        error={errors.permissionFrom}
                        disabled={!iseditatable}
                        success={
                          permission.permissionFrom &&
                          !errors.permissionFrom &&
                          !errors.timeOrder
                        }
                      />
                      {/* {
                        errors.timeOrder? <span style={{color:"red",fontSize:"15px"}}>
                          from time should be lesser than till time
                        </span>:null
                      } */}
                    </Grid2>
      
                    <Grid2 size={{ xs: 12, sm:12, md: 6, lg: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Permission Till <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
      
                      <MaterialInput
                        name="permissionTill"
                        type="time"
                        value={permission.permissionTill}
                        onChange={handleChange}
                        disabled={!iseditatable}
                        error={
                          errors.permissionTill ||
                          errors.timeOrder ||
                          permission.permissionTillStatus == "error"
                        }
                        success={
                          permission.permissionTill &&
                          !errors.permissionTill &&
                          !errors.timeOrder
                        }
                      />
                      {errors.timeOrder ? (
                        <span style={{ color: "red", fontSize: "15px" }}>
                          From time should be lesser than till time
                        </span>
                      ) : null}
      
                      {permission.permissionTillStatus == "error" && (
                        <span style={{ color: "red", fontSize: "15px" }}>
                          Time difference should not exceed 2 hours!
                        </span>
                      )}
                    </Grid2>
      
                  
      
                    <Grid2 size={{ xs: 12, sm:12, md: 12, lg: 12 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Reason <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
      
                      <MaterialInput
                        multiline
                        rows={4}
                        name="reason"
                        // placeholder="eg. IT"
                        value={permission.reason}
                        onChange={handleDepartmentDatachange}
                        disabled={!iseditatable}
                        error={permission.reasonStatus === "error"}
                        success={permission.reasonStatus === "success"}
                        //   success={roleData.descriptionStatus === "success"}
                        //   disabled={togglePage.view === true ? true : false}
                      />
                      {permission.reasonStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Department Name should be a maximum of 40 characters long
                            and can contain only alphabets.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Grid2>
                  </Grid2>
              </MaterialBox>
              {/* Form Actions */}
              <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center">
                      {iseditatable && (
                        <>
                          <MaterialButton
                            sx={{ m: 1, marginLeft: "4px" }}
                            variant="gradient"
                            color="dark"
                            size="small"
                            endIcon={<Send />}
                            disabled={!isFormValid()}
                            onClick={confirmsubmit}
                          >
                            Apply
                          </MaterialButton>
                        </>
                      )}
                      {id && (
                        <>
                          <MaterialButton
                            sx={{ m: 2, marginLeft: "4px" }}
                            variant="gradient"
                            color="dark"
                            size="small"
                            endIcon={<Send/>}
                            disabled={!isFormValid()}
                            onClick={confirmsubmit}
                          >
                            Update
                          </MaterialButton>
                        </>
                    )}
              </MaterialBox> 
              </>
              }
            </>
        </MaterialBox>
      </Slide>

    </>
    // <Dialog 
    //   open={permissionOpen}
    //   onClose={(event, reason) => {
    //     if (reason !== 'backdropClick') handleClosePermission();
    //   }}
    // >
    // <DialogTitle>
    //     <IconButton
    //     onClick={handleClosePermission}
    //     >
    //         <ArrowBackIcon />
    //     </IconButton> 
    //     Apply Permission Form
    //     </DialogTitle>
    //   <DialogContent>
    //     {/* <AddLeaveRequest /> */}
    //     <MaterialInput
    //     type="date"
    //     value={selectedDate}
    //     />
    //   </DialogContent>
    //   <DialogActions>
    //     <MaterialButton 
    //     onClick={handleClosePermission}
    //     >
    //     Submit
    //     </MaterialButton>
    //   </DialogActions>
    // </Dialog>
  );
};


export default PermissionDialog